const TABS = ":is(.js-responsive-tabs, .vut-tabs ul.nav-tabs)";
window.addEventListener('DOMContentLoaded', function(){

    if (!document.querySelector(TABS)) return;

    document.head.insertAdjacentHTML("beforeend", "<style>"+TABS+" {white-space:nowrap; position:relative; flex-wrap:nowrap;} "+TABS+">li {float:none; display:inline-block;} "+TABS+">li>a {float:none; display:inline-block; cursor:pointer;} "+TABS+" .dropdown-menu {position:absolute; left:auto !important; right:0px;} </style>")

    var timeout;
    var f=function(e, w){

        if (e) {
            if (e.type=="click") {
                if (!f.dropdownOpened) {return true;}
                var target=e.target;
                while (target.parentNode) {
                    if (target.classList.contains("more")) {return true;}
                    target=target.parentNode;
                }
            } else {
                clearTimeout(timeout);
                timeout=setTimeout(function(){f()}, 200);
                return true;
            }
        }

        var main=document.querySelector(".main, .vut-main");
        main.style.overflow="hidden";
        var width=w||(main.offsetWidth-(function(){var s=getComputedStyle(main); return Math.ceil(parseFloat(s["padding-left"])+parseFloat(s["padding-right"]))})());
        if (width>1900) {width=1900;}

        var containers=document.querySelectorAll(TABS);

        containers.forEach(container=>{
            container.classList.add("responsive-tabs-container");
            container.style.width=width+"px";
//            container.style.overflow="hidden";
            while (container.querySelector(".dropdown-menu")) {container.querySelector(".dropdown-menu").parentNode.removeChild(container.querySelector(".dropdown-menu"));}
            container.querySelector(".more")?.remove?.();
            var tabs=container.querySelectorAll("li");
            tabs.forEach(tab=>{
                tab.classList.remove("d-none");
                tab.classList.remove("hidden");
                tab.style.display="";
                if (tab.querySelector("a")) {tab.querySelector("a").style.display="";}
            });

            if (tabs.length>2) {
                if (container.scrollWidth>container.offsetWidth) {
                    container.insertAdjacentHTML("beforeEnd", '<li class="nav-item more"><a class="nav-link">'+(window.gl_lang_code=="cs"?"Více":"More")+'... (<span class="more_count">'+(tabs.length)+'</span>)</a></li>')
                    var hidden=0;
                    for (var ii=tabs.length-1; ii>=0; ii--) {
                        var tab=tabs[ii];
                        if (!tab.matches(".more, .active, :has(.active)")) {
                            tab.classList.add("d-none");
                            tab.classList.add("hidden");
                            hidden++;
                        }
                        if ((container.scrollWidth<=container.offsetWidth)&&(hidden>1)) {break;}
                    }
                    /*                if (container.scrollWidth>container.offsetWidth) {
                                        var tab=container.querySelector(".active");
                                        tab.classList.add("hidden");
                                        hidden++;
                                    }*/
                    container.querySelector(".more_count").innerText=hidden;
                    if (container.scrollWidth>container.offsetWidth) {
                        container.querySelector(".more").style.float="right";
                    } else {
                        container.querySelector(".more").style.position="absolute";
                        container.querySelector(".more").style.right="0px";//"28px";
                    }


                    container.querySelector(".more").onclick=function(){
                        while (document.querySelector(TABS+" .dropdown-menu")) {
                            document.querySelector(TABS+" .dropdown-menu").remove();
                        }
                        if (f.dropdownOpened) {f.dropdownOpened=false; return;}
                        if (!this.parentNode) return;
                        this.insertAdjacentHTML("beforeend", '<ul class="dropdown-menu"></ul>');
                        var dropdown=this.parentNode.querySelector(".dropdown-menu");
                        //dropdown.innerHTML='<div class="dropdown-header visible-xs"><p class="count">Záložky<button type="button" class="close"><span>×</span></button></p><div class="divider visible-xs"></div></div>';
                        var container=this.parentNode;
                        dropdown.style.display="block";
                        dropdowns=[];
                        var tabs=container.querySelectorAll("li.hidden");
                        for (var i=0, l=tabs.length; i<l; i++) {
                            dropdown.innerHTML+=tabs[i].outerHTML;
                            dropdowns[i]=tabs[i];
                        }
                        var tabs=dropdown.querySelectorAll("li.hidden");
                        for (var i=0, l=tabs.length; i<l; i++) {
                            tabs[i].classList.remove("d-none");
                            tabs[i].classList.remove("hidden");
                            tabs[i].dataset.i=i;
                            tabs[i].onclick=function(e){this.parentNode.parentNode.parentNode.querySelectorAll("li.hidden")[this.dataset.i].querySelector("a").click(); e.preventDefault(); return false;}
                        }

                        f.dropdownOpened=true;
                    }
                }
            } else if (tabs.length==2) {
                if (container.scrollWidth>container.offsetWidth) {
                    for (var ii=0, ll=tabs.length; ii<ll; ii++) {
                        var tab=tabs[ii];
                        tab.style.display="block";
                        if (tab.querySelector("a")) {tab.querySelector("a").style.display="block";}
                    }
                }
            }

//            container.style.overflow="";

        });

        main.style.overflow="";
        f.dropdownOpened=false;

    }

    f();
    f.dropdownOpened=false;

    if ((typeof window.VUTResizeHandler == "object")&&(typeof window.VUTResizeHandler.add == "function")) {
        VUTResizeHandler.add(f);
    } else {
        window.addEventListener("resize", f);
    }
    document.addEventListener("click", f);

}, true);